export enum USER_PERMISSION_TYPES {
    READ_WRITE = 'isReadWrite',
    READ_ONLY = 'isReadOnly',
    DISABLED = 'isDisabled',
}
